const InsuranceChallenge2Dataset = {
    items: {
        "item-1": { id: "item-1", content: "Read your policy carefully so you know what's excluded before " +
                "you actually need to file a claim.", 
                answer: "column-2" },
        "item-2": { id: "item-2", content: "If you're young and healthy you can skip health insurance " +
                "and just pay out of pocket if something comes up.", 
                answer: "column-3" },
        "item-3": { id: "item-3", content: "Just pick the cheapest insurance plan you can find. " +
                "They're basically all the same.",
                answer: "column-3" },
        "item-4": { id: "item-4", content: "Keep a home inventory. Photos or a video walkthrough " +
                "of your belongings in case you ever need to file a claim.",
                answer: "column-2" },
        "item-5": { id: "item-5", content: "If you live in an apartment you don’t need to worry " +
                "about insurance because your landlord's insurance covers your stuff if there's a fire or theft. " , 
                answer: "column-3" },
        "item-6": { id: "item-6", content: "A higher deductible usually means a lower monthly premium.", 
                answer: "column-2" },   
        "item-7": { id: "item-7", content: "Once you have insurance, you don't need to worry about " +
                "an emergency fund anymore.", 
                answer: "column-3" },   
        "item-8": { id: "item-8", content: "If someone hits your parked car and drives off, there's " +
                "nothing your insurance can do.", 
                answer: "column-3" }
    },

    columns: {
        "column-1": { id: "column-1", title: "Insurance Advice", 
            itemIds: ['item-1', 'item-2', 'item-3', "item-4", "item-5", "item-6", "item-7", "item-8"] },
        "column-2": { id: "column-2", title: "Advice that is Good", itemIds: [] },
        "column-3": { id: "column-3", title: "Advice that is Not Good", itemIds: []},
       
    },

    columnOrder: ["column-1", "column-2", "column-3"]
}

export default InsuranceChallenge2Dataset